module.exports = __webpack_public_path__ + "static/media/icone_criar_lead.e71a7584.svg";